import { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
import { proposalExpiryBadgeLabel } from '../../lib/proposals';

interface ProposalExpiryBadgeProps {
  validUntil?: string | null;
}

/** Sits beside the proposal pill on a lead card. */
export default function ProposalExpiryBadge({ validUntil }: ProposalExpiryBadgeProps) {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    if (!validUntil) return;
    setNow(new Date());
    const timer = setInterval(() => setNow(new Date()), 60_000);
    return () => clearInterval(timer);
  }, [validUntil]);

  const label = proposalExpiryBadgeLabel(validUntil, now);
  if (!label) return null;

  const expired = label === 'Expired';

  return (
    <span
      className={`inline-flex items-center gap-1 text-[10px] font-medium px-2 py-0.5 rounded-full ${
        expired ? 'text-red-700 bg-red-50' : 'text-amber-800 bg-amber-50'
      }`}
    >
      <Clock className="w-2.5 h-2.5" />
      {label}
    </span>
  );
}
